var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"p-3",attrs:{"id":"app"}},[_c('Index',{attrs:{"msg":"Markedoc生成器"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }